import React, { useState } from 'react';

const Timeline = () => {

    const [activeBox, setActiveBox] = useState(null);
    const [activeCircle, setActiveCircle] = useState(null);

    const handleMouseEnter = (boxId) => {
        setActiveBox(boxId);
        setActiveCircle(boxId);
    };

    return (
        <div className="flex flex-col items-center mt-20 w-full">
            <div className="relative flex justify-between items-center w-full px-16">

                <div className="absolute left-0 right-0 h-1.5 bg-[#6c4e52]" style={{ top: '50%' }}></div>

                {/* Circle 1 with label */}
                <div className="relative z-10">
                    <div className="absolute right-3 -top-12 transform translate-x-2/4">
                        <button
                            className={`text-xs font-bold text-[#c94c67] transform transition-transform duration-300 ease-in-out ${activeCircle === 1 ? 'scale-125' : ''}`}
                            onMouseEnter={() => handleMouseEnter(1)}
                        >
                            Define the project
                        </button>
                    </div>
                    <button
                        onMouseEnter={() => handleMouseEnter(1)}
                        className={`rounded-full h-6 w-6 bg-pink-300 border-2 border-white mt-2 transform transition-transform duration-300 ease-in-out ${activeCircle === 1 ? 'scale-125 bg-[#c94c67]' : ''}`}
                    ></button>
                    {/* Box 1 */}
                    {activeBox === 1 && (
                        <div className="absolute left-0 transform translate-x-0 mt-4 w-80 pl-4 pt-2 pb-2 bg-pink-100 rounded-3xl shadow-lg">
                    
                            <ul className='list-disc'>
                                <li className="flex items-center">
                                    - Prof. Dr. Jin-Sheng Chen
                                </li>
                                <li className="flex items-center">
                                    - Prof  Dr. Kun-Hsien Tsai
                                </li>
                                {/* <li className="flex items-center">
                                    - Prof. Chen and Prof. Tsai
                                    <img src={profile} alt='profile' className='w-5 h-5 ml-2' />
                                </li>
                                <li className="flex items-center">
                                    - Prof. Jason Wang, Stanford
                                    <img src={profile} alt='profile' className='w-5 h-5 ml-2' />
                                </li>
                                <li className="flex items-center">
                                    - Dr. Goncalo, MENTOR initiative
                                    <img src={profile} alt='profile' className='w-5 h-5 ml-2' />
                                </li>
                                <li className="flex items-center">
                                    - Prof. Cohen
                                    <img src={profile} alt='profile' className='w-5 h-5 ml-2' />
                                </li>
                                <li className="flex items-center">
                                    - Ms. Chan, GM, Fumakilla Malaysia
                                    <img src={profile} alt='profile' className='w-5 h-5 ml-2' />
                                </li> */}
                            </ul>

                        </div>
                    )}
                </div>

                {/* Circle 2 with label */}
                <div className="relative z-10">
                    <div className="absolute top-9 -translate-x-5 text-center">
                        <button
                            className={`text-xs font-bold text-[#c94c67] transform transition-transform duration-300 ease-in-out ${activeCircle === 2 ? 'scale-125' : ''}`}
                            onMouseEnter={() => handleMouseEnter(2)}
                        >
                            Idea Verification
                        </button>
                    </div>
                    <button
                        onMouseEnter={() => handleMouseEnter(2)}
                        className={`rounded-full h-6 w-6 bg-pink-300 border-2 border-white mt-2 transform transition-transform duration-300 ease-in-out ${activeCircle === 2 ? 'scale-125 bg-[#c94c67]' : ''}`}
                    ></button>
                    {/* Box 2 */}
                    {activeBox === 2 && (
                        <div className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-4 p-2 w-72 bg-[#f8ccd9] rounded-3xl shadow-lg">
                            <ul className='list-disc'>
                                <li className="flex items-center">
                                    - Dr. Chen Chee Dhang
                                </li>
                                

                                <li className="flex items-center">
                                    - Associate Prof. Dr. Low Van Lun
                                </li>
                                <li className="flex items-center">
                                    - Prof. Dr. Stanley Norman Cohen                                    
                                </li>
                            </ul>
                        </div>
                    )}
                </div>

                {/* Circle 3 with label */}
                <div className="relative z-10">
                    <div className="absolute left-1/2 -top-9 transform -translate-x-1/2">
                        <button
                            className={`text-xs font-bold text-[#c94c67] transform transition-transform duration-300 ease-in-out ${activeCircle === 3 ? 'scale-125' : ''}`}
                            onMouseEnter={() => handleMouseEnter(3)}
                        >

                            Real Field Implementation
                        </button>
                    </div>
                    <button
                        onMouseEnter={() => handleMouseEnter(3)}
                        className={`rounded-full h-6 w-6 bg-pink-300 border-2 border-white mt-2 transform transition-transform duration-300 ease-in-out ${activeCircle === 3 ? 'scale-125 bg-[#c94c67]' : ''}`}
                    ></button>
                    {/* Box 3 */}
                    {activeBox === 3 && (
                        <div className="absolute left-1/2 transform -translate-x-1/2 mt-4 p-8 w-72 bg-pink-100 rounded-3xl shadow-lg">
                            <li className="flex items-center">
                                - WiAdvance

                            </li>
                            <li className="flex items-center">
                                - John Cumbers

                            </li>
                            <li className="flex items-center">
                                - Ms. Yew Lin, Chan

                            </li>
                            <li className="flex items-center">
                                - Mr. Kong KC
                            </li>
                            <li className="flex items-center">
                                - Dr. Ling Wong
                            </li>
                        </div>
                    )}
                </div>

                {/* Circle 4 with label */}
                <div className="relative z-10">
                    <div className="absolute text-center left-1/2 -bottom-10 transform -translate-x-1/2">
                        <button
                            className={`text-xs font-bold text-[#c94c67] transform transition-transform duration-300 ease-in-out ${activeCircle === 4 ? 'scale-125' : ''}`}
                            onMouseEnter={() => handleMouseEnter(4)}
                        >
                            Social Implementation
                        </button>
                    </div>
                    <button
                        onMouseEnter={() => handleMouseEnter(4)}
                        className={`rounded-full h-6 w-6 bg-pink-300 border-2 border-white mt-2 transform transition-transform duration-300 ease-in-out ${activeCircle === 4 ? 'scale-125 bg-[#c94c67]' : ''}`}
                    ></button>
                    {/* Box 4 */}
                    {activeBox === 4 && (
                        <div className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-4 p-8 w-72 bg-[#f8ccd9] rounded-3xl shadow-lg">
                            <li className="flex items-center">
                                - Prof. Jason Wang

                            </li>
                            <li className="flex items-center">
                                - Gonçalo Martins Alves
                            </li>
                            <li className="flex items-center">

                                - Dr. Diana Rojas Alvarez
                            </li>
                            <li className="flex items-center">
                                - Taiwan CDC
                            </li>
                        </div>
                    )}
                </div>

            </div>
        </div>
    );
};

export default Timeline;
